export { default } from '../../stories-details/index';
